import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/',
});

api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('access_token');

        // Если для данного запроса указано withoutAuth: true, то не добавляем токен.
        // Иначе, если токен есть — добавляем.
        if (!config.withoutAuth && token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            // Если не нужны токены или их нет, убедимся, что Authorization не добавлен
            delete config.headers.Authorization;
        }

        config.headers['X-API-KEY'] = process.env.REACT_APP_API_KEY || '473f9e45eb72ba7960ba6e8bab7accd9382ec10e6261e057b8350de4cf1adfcb';
        // console.log('Request made to:', config.baseURL + config.url);
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.error('Error response:', error);
        if (error.response) {
            console.error('Error response data:', error.response.data);
        }
        return Promise.reject(error);
    }
);

export default api;
